import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as LinkedInIcon } from './linkedIn.svg';

export const LinkedIn = IconHOC(LinkedInIcon);
